module.exports = __webpack_public_path__ + "assets/img/networkAnalysis-active.1ad74fe2.svg";